module.exports = __webpack_public_path__ + "files/ac6c346562073164218697af1c958b41.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Arvo-regular.woff2
 ** module id = 847
 ** module chunks = 0
 **/